import { Changes, em, headRow, td, th } from './logistics';

function show(v: unknown) {
  if (v === null || v === undefined || v === '') return '–';
  return String(v);
}

/** The head note of a "send it yourself" section: when it was last sent and how much changed since. */
export function sentNote(lastSent: string | null, changes: number, at: (iso: string) => string) {
  if (!lastSent) return 'Not sent yet · the whole list is new';
  return `Last sent ${at(lastSent)} · ${changes ? `${changes} ${changes === 1 ? 'change' : 'changes'} since` : 'no changes since'}`;
}

/** What changed since the last list sent, as a short table: Change · Person · What. Nothing when there is nothing. */
export default function ChangesTable({ changes, labels = {} }: { changes: Changes; labels?: Record<string, string> }) {
  if (!changes.sentBefore) return null;
  const rows = [
    ...changes.added.map((r) => ({ kind: 'Added', r })),
    ...changes.changed.map((r) => ({ kind: 'Changed', r })),
    ...changes.removed.map((r) => ({ kind: 'Removed', r })),
  ];
  if (!rows.length) return null;
  return (
    <div className="mt-8">
      <h3 className="text-[15px] leading-[22px] font-semibold text-ink mb-2">
        Changes since the last list sent · {rows.length}
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full max-w-[820px] tabular">
          <thead>
            <tr className={headRow}>
              <th className={`${th} w-[110px]`}>Change</th>
              <th className={th}>Person</th>
              <th className={th}>What</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ kind, r }) => (
              <tr key={`${kind}${r.key}`} className="border-b border-line">
                <td className={td}>{kind}</td>
                <td className={td}>{r.name}</td>
                <td className={td}>
                  {kind === 'Changed' && r.changes?.length ? (
                    r.changes.map((c) => (
                      <span key={c.field} className="block">
                        {labels[c.field] ?? c.field} {show(c.from)} → {show(c.to)}
                      </span>
                    ))
                  ) : (
                    <span className={em}>–</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
